import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// auth
import logOutAndRedirect from "helpers/log-out";

// components
import Button from "core/Button";

//styles
const ButtonStyled = styled(Button)`
    width: 100%;
`;

// component
const LogoutButton = ({ className }) => {
    const {
        isDarkMode,
        viewport: { isMobile }
    } = useSiteHeader();

    return (
        <ButtonStyled
            className={className}
            onClick={logOutAndRedirect}
            styleType="outline"
            size="md"
            darkMode={!isMobile && isDarkMode}
        >
            Log Out
        </ButtonStyled>
    );
};

export default LogoutButton;

// prop-types
LogoutButton.propTypes = {
    className: PropTypes.string
};
